<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 381 444" enable-background="new 0 0 381 444" xml:space="preserve">
<path fill="#FFAB00" opacity="1.000000" stroke="none" 
	d="
M247.060486,118.904251 
	C264.054443,118.936096 281.048370,118.968460 298.042328,118.999588 
	C308.294556,119.018372 312.319275,124.614899 310.245667,134.577667 
	C307.431885,148.096542 306.029510,161.675858 307.785919,175.650757 
	C309.377930,188.317947 311.723297,200.609787 316.879883,212.994034 
	C312.304169,217.139771 307.683563,220.611191 303.034760,223.692795 
	C302.358276,221.247253 301.845062,219.137009 301.041016,217.144104 
	C291.155579,192.642715 288.946655,167.243622 292.213593,141.232162 
	C292.994995,135.010574 293.194397,135.006973 287.213837,135.006348 
	C220.739975,134.999374 154.266113,134.999603 87.792259,135.014709 
	C86.039276,135.015106 84.286339,135.205292 82.358978,135.317093 
	C82.415466,136.561523 82.372749,137.215012 82.484200,137.841064 
	C84.912178,151.479919 85.418823,165.266174 83.801270,178.944778 
	C81.580269,197.726501 76.109108,215.631851 67.295670,232.506836 
	C54.255894,257.473969 50.497337,284.135071 53.949841,311.888611 
	C57.626194,341.441650 70.449356,366.757751 90.825180,388.181091 
	C102.618721,400.580902 116.652245,410.142670 132.320084,417.130127 
	C158.765182,428.923950 186.248993,432.057861 214.621002,426.257477 
	C246.644806,419.710541 272.805481,403.474823 293.436005,378.122223 
	C301.234253,368.539093 301.435059,368.690399 292.136658,360.610992 
	C271.712311,342.864319 251.288651,325.116913 230.844818,307.392700 
	C227.654556,304.626831 224.359634,301.981689 220.339783,298.637329 
	C220.813889,302.106812 221.014954,304.547302 221.494247,306.931885 
	C225.215912,325.448120 211.850327,341.988464 193.108322,342.000977 
	C188.943298,342.003754 184.778214,342.013550 180.613251,341.998505 
	C168.301849,341.954010 155.619019,331.927429 154.260254,319.678253 
	C153.459763,312.461792 154.712708,304.925446 155.718781,297.626251 
	C156.750534,290.140808 157.529663,283.463043 152.096619,276.655060 
	C145.067215,267.846710 144.793427,256.817780 146.568085,246.100327 
	C149.550568,228.088669 168.543381,212.233185 188.649796,212.650375 
	C207.818329,213.048080 226.834671,229.017059 228.562576,246.903931 
	C225.755676,247.034302 223.387558,247.091537 220.578918,247.081207 
	C217.773392,246.954437 215.408356,246.895248 212.997223,246.482468 
	C207.579941,232.124619 194.731461,224.965225 181.315628,228.501007 
	C161.678497,233.676407 154.605637,257.828491 168.545166,272.604980 
	C172.532898,276.832153 174.212662,281.267670 173.108795,287.059021 
	C171.615677,294.892395 170.570724,302.811249 169.337479,310.694061 
	C167.954102,319.536346 173.356949,326.037018 182.335327,326.277618 
	C185.163300,326.353424 187.994965,326.300262 190.824905,326.293457 
	C202.509613,326.265411 207.568207,320.447540 205.823502,308.918915 
	C204.753799,301.850464 203.673676,294.778748 202.353058,287.754639 
	C201.256607,281.922729 202.421494,277.118469 206.673920,272.688385 
	C209.232422,270.023010 210.726807,266.336182 213.074982,262.996887 
	C215.651398,262.808044 217.852188,262.730743 220.490906,262.750732 
	C223.619812,262.918304 226.310822,262.988586 228.986694,263.440216 
	C226.630219,268.914154 224.698517,274.255371 221.809494,279.015594 
	C219.741409,282.423096 220.378876,284.203674 223.122849,286.501984 
	C234.061111,295.663757 244.921234,304.920654 255.716919,314.250397 
	C269.154175,325.862976 282.473511,337.612000 295.901825,349.234985 
	C299.330597,352.202759 302.978546,354.917267 306.781006,357.951782 
	C317.068665,338.709839 321.783264,318.858368 323.394592,298.037231 
	C328.867920,298.725159 333.942291,299.434937 339.009460,300.581543 
	C338.315979,307.686737 338.174561,314.465973 336.844574,321.003418 
	C332.242706,343.623047 323.794952,364.706543 309.914917,383.321136 
	C296.227905,401.676971 279.554047,416.693878 259.166534,427.381927 
	C244.429932,435.107544 229.027267,440.835083 212.445068,443.103058 
	C211.887329,443.179352 211.478333,444.343140 211.000000,445.000000 
	C199.645767,445.000000 188.291550,445.000000 176.156372,444.745605 
	C161.446594,443.089539 147.890930,440.143585 134.784210,435.111908 
	C98.638145,421.235413 71.517532,397.135406 53.545998,362.939789 
	C41.568386,340.149231 36.460308,315.746002 36.855198,289.925903 
	C37.200958,267.318298 42.545403,246.043961 52.739605,226.189133 
	C67.572487,197.299744 72.353806,167.291687 65.893913,135.468018 
	C63.949123,125.887329 64.669434,124.399155 72.983383,119.167564 
	C81.334427,119.106331 89.685478,119.045097 98.879272,119.116158 
	C107.844933,119.144135 115.967834,119.039818 124.552612,118.963501 
	C157.009644,118.939049 189.004822,118.886597 221.396271,118.968094 
	C230.215195,119.036110 238.637833,118.970177 247.060486,118.904251 
z"/>
<path fill="#FF991F" opacity="1.000000" stroke="none" 
	d="
M72.520744,119.095566 
	C64.669434,124.399155 63.949123,125.887329 65.893913,135.468018 
	C72.353806,167.291687 67.572487,197.299744 52.739605,226.189133 
	C42.545403,246.043961 37.200958,267.318298 36.855198,289.925903 
	C36.460308,315.746002 41.568386,340.149231 53.545998,362.939789 
	C71.517532,397.135406 98.638145,421.235413 134.784210,435.111908 
	C147.890930,440.143585 161.446594,443.089539 175.687714,444.745605 
	C160.645767,445.000000 145.291550,445.000000 129.778259,444.650391 
	C125.878403,443.442566 122.118134,442.660767 118.399826,441.714203 
	C87.031189,433.728363 59.990349,418.667023 38.414673,394.038940 
	C19.840532,372.837036 7.889786,348.657623 2.924875,320.950348 
	C2.792042,320.209076 1.663966,319.646118 1.000002,319.000000 
	C1.000000,302.645782 1.000000,286.291534 0.999996,269.468658 
	C1.657366,268.512177 2.819925,268.094330 2.898564,267.526398 
	C5.132558,251.392044 11.166266,236.590363 18.361267,222.135468 
	C26.265448,206.255798 30.760366,189.519867 32.216774,171.706085 
	C33.289520,158.584991 31.578289,145.995346 29.171949,133.287781 
	C27.758022,125.821022 31.148224,118.751480 40.575768,118.951416 
	C51.065670,119.173882 61.563644,119.015915 72.520744,119.095566 
z"/>
<path fill="#2885FD" opacity="1.000000" stroke="none" 
	d="
M382.000000,265.531433 
	C381.323486,266.633881 380.287476,267.145752 380.024597,267.920044 
	C376.268860,278.983704 370.172699,288.446533 359.538086,293.700287 
	C353.431671,296.716949 346.455933,297.973846 339.444092,300.083862 
	C333.942291,299.434937 328.867920,298.725159 323.093262,297.840759 
	C305.963257,291.681458 295.966492,279.977661 291.952545,263.058899 
	C270.813324,263.058899 249.907562,263.058899 229.001816,263.058899 
	C226.310822,262.988586 223.619812,262.918304 220.380249,262.419952 
	C215.489090,255.664749 215.674881,253.342865 221.019424,247.148788 
	C223.387558,247.091537 225.755676,247.034302 229.026138,246.977142 
	C250.559967,246.977219 271.191467,246.977219 290.134430,246.977219 
	C294.822296,238.675613 298.942627,231.379105 303.062927,224.082581 
	C307.683563,220.611191 312.304169,217.139771 317.043915,213.333588 
	C333.250275,206.735916 348.657288,207.911209 362.782257,218.048676 
	C371.276550,224.145050 378.020020,231.844147 380.074677,242.668076 
	C380.209412,243.377777 380.921204,243.977921 381.682312,244.314514 
	C382.000000,251.020950 382.000000,258.041901 382.000000,265.531433 
M311.484161,239.585953 
	C303.090271,254.700592 307.642456,272.162201 322.492767,280.432373 
	C327.815094,282.686890 333.035278,285.614960 339.901245,282.990601 
	C352.738922,280.856781 360.677277,272.881042 363.459625,260.749512 
	C366.208771,248.762756 361.595612,238.507538 351.651001,231.340637 
	C343.405579,225.398315 334.277618,223.961884 324.102936,228.928787 
	C318.472412,230.451172 314.927979,234.432755 311.484161,239.585953 
z"/>
<path fill="#0165FE" opacity="1.000000" stroke="none" 
	d="
M124.090744,118.935501 
	C115.967834,119.039818 107.844933,119.144135 99.342911,119.062485 
	C98.975639,106.387657 98.984108,93.898804 99.000046,81.409966 
	C99.029884,58.028816 107.375343,38.155956 124.960808,22.708393 
	C135.200928,13.713183 147.046722,7.786124 160.986969,5.821840 
	C175.908676,3.719259 190.181198,5.406960 203.664429,11.468713 
	C217.369492,17.630196 228.204666,27.457977 236.207870,40.450184 
	C244.113235,53.283562 247.119339,67.179596 247.018066,82.012444 
	C246.936218,94.001320 247.006912,105.991249 247.035217,118.442474 
	C238.637833,118.970177 230.215195,119.036110 221.395905,118.510094 
	C220.999207,103.778122 221.301865,89.629684 220.909348,75.500557 
	C220.554672,62.733482 215.330536,51.348507 206.114609,42.989479 
	C191.353378,29.600775 174.055756,24.810946 154.717346,32.996284 
	C136.507202,40.704060 125.225227,56.133587 124.162842,75.529305 
	C123.372612,89.956070 124.060944,104.463821 124.090744,118.935501 
z"/>
<path fill="#FFC400" opacity="1.000000" stroke="none" 
	d="
M303.034760,223.692780 
	C298.942627,231.379105 294.822296,238.675613 290.134430,246.977219 
	C271.191467,246.977219 250.559967,246.977219 229.464905,246.904022 
	C226.834671,229.017059 207.818329,213.048080 188.649796,212.650375 
	C168.543381,212.233185 149.550568,228.088669 146.568085,246.100327 
	C144.793427,256.817780 145.067215,267.846710 152.096619,276.655060 
	C157.529663,283.463043 156.750534,290.140808 155.718781,297.626251 
	C154.712708,304.925446 153.459763,312.461792 154.260254,319.678253 
	C155.619019,331.927429 168.301849,341.954010 180.613251,341.998505 
	C184.778214,342.013550 188.943298,342.003754 193.108322,342.000977 
	C211.850327,341.988464 225.215912,325.448120 221.494247,306.931885 
	C221.014954,304.547302 220.813889,302.106812 220.339783,298.637329 
	C224.359634,301.981689 227.654556,304.626831 230.844818,307.392700 
	C251.288651,325.116913 271.712311,342.864319 292.136658,360.610992 
	C301.435059,368.690399 301.234253,368.539093 293.436005,378.122223 
	C272.805481,403.474823 246.644806,419.710541 214.621002,426.257477 
	C186.248993,432.057861 158.765182,428.923950 132.320084,417.130127 
	C116.652245,410.142670 102.618721,400.580902 90.825180,388.181091 
	C70.449356,366.757751 57.626194,341.441650 53.949841,311.888611 
	C50.497337,284.135071 54.255894,257.473969 67.295670,232.506836 
	C76.109108,215.631851 81.580269,197.726501 83.801270,178.944778 
	C85.418823,165.266174 84.912178,151.479919 82.484200,137.841064 
	C82.372749,137.215012 82.415466,136.561523 82.358978,135.317093 
	C84.286339,135.205292 86.039276,135.015106 87.792259,135.014709 
	C154.266113,134.999603 220.739975,134.999374 287.213837,135.006348 
	C293.194397,135.006973 292.994995,135.010574 292.213593,141.232162 
	C288.946655,167.243622 291.155579,192.642715 301.041016,217.144104 
	C301.845062,219.137009 302.358276,221.247253 303.034760,223.692780 
M253.219147,219.527679 
	C247.580688,219.528748 241.936981,219.400024 236.307648,219.627274 
	C234.993561,219.680328 233.728256,220.941711 232.440506,221.647156 
	C233.734421,222.363770 235.006866,223.649445 236.325943,223.699234 
	C242.287643,223.924149 248.271622,223.988083 254.227829,223.700653 
	C256.372559,223.597153 258.461884,222.346298 260.576508,221.619049 
	C258.427887,220.922256 256.279266,220.225449 253.219147,219.527679 
M132.129059,327.529907 
	C126.141136,327.531281 120.148819,327.411407 114.168709,327.628082 
	C112.844543,327.676025 111.563461,328.913177 110.262535,329.602753 
	C111.583649,330.333405 112.886154,331.653107 114.229019,331.695587 
	C121.041786,331.910797 127.866997,331.880341 134.682983,331.723999 
	C136.083160,331.691833 137.462585,330.755127 138.851593,330.235382 
	C138.823914,329.648895 138.796249,329.062408 138.768585,328.475922 
	C136.853226,328.161011 134.937881,327.846100 132.129059,327.529907 
M158.797318,370.441742 
	C158.798355,372.274384 158.550568,374.153198 158.879471,375.924957 
	C159.140762,377.332581 160.107483,378.609283 160.761017,379.944092 
	C161.468307,378.676025 162.752899,377.423462 162.787430,376.137299 
	C162.984100,368.812073 162.984604,361.476044 162.785461,354.150940 
	C162.750900,352.880310 161.443329,351.644287 160.723785,350.392273 
	C160.082596,351.750488 158.950851,353.086548 158.888321,354.470856 
	C158.663025,359.458801 158.798187,364.463043 158.797318,370.441742 
M207.995346,176.823151 
	C207.995392,183.155014 207.864090,189.491425 208.083298,195.815704 
	C208.141678,197.499741 209.274323,199.146545 209.913742,200.810455 
	C210.610306,199.228149 211.853378,197.664459 211.908096,196.060272 
	C212.135147,189.402893 212.105530,182.730576 211.928894,176.070145 
	C211.886749,174.480988 210.914337,172.916519 210.369797,171.340683 
	C209.578384,172.865265 208.786972,174.389847 207.995346,176.823151 
M230.988388,203.595871 
	C235.457657,199.123596 239.995087,194.715805 244.337418,190.123505 
	C245.184006,189.228165 245.272491,187.616013 245.710663,186.334488 
	C244.285797,186.703583 242.455933,186.635025 241.504410,187.515594 
	C236.744705,191.920380 232.142242,196.504303 227.663193,201.195847 
	C226.707642,202.196747 226.494888,203.906815 225.939926,205.290161 
	C227.448425,204.892319 228.956924,204.494476 230.988388,203.595871 
M135.020264,352.516937 
	C132.005981,355.612152 128.898911,358.625610 126.046432,361.863373 
	C125.380730,362.618988 125.579453,364.136139 125.380455,365.302887 
	C126.524536,365.113464 128.068146,365.333588 128.749023,364.669342 
	C133.863052,359.680511 138.861542,354.568329 143.742691,349.351166 
	C144.438461,348.607513 144.307755,347.090576 144.559555,345.931519 
	C143.293915,346.181091 141.730423,346.049835 140.824051,346.758759 
	C138.876968,348.281647 137.268570,350.237549 135.020264,352.516937 
z"/>
<path fill="#FFC400" opacity="1.000000" stroke="none" 
	d="
M228.986694,263.440247 
	C249.907562,263.058899 270.813324,263.058899 291.952545,263.058899 
	C295.966492,279.977661 305.963257,291.681458 322.694275,297.862640 
	C321.783264,318.858368 317.068665,338.709839 306.781006,357.951782 
	C302.978546,354.917267 299.330597,352.202759 295.901825,349.234985 
	C282.473511,337.612000 269.154175,325.862976 255.716919,314.250397 
	C244.921234,304.920654 234.061111,295.663757 223.122849,286.501984 
	C220.378876,284.203674 219.741409,282.423096 221.809494,279.015594 
	C224.698517,274.255371 226.630219,268.914154 228.986694,263.440247 
z"/>
<path fill="#273957" opacity="1.000000" stroke="none" 
	d="
M212.699387,263.108398 
	C210.726807,266.336182 209.232422,270.023010 206.673920,272.688385 
	C202.421494,277.118469 201.256607,281.922729 202.353058,287.754639 
	C203.673676,294.778748 204.753799,301.850464 205.823502,308.918915 
	C207.568207,320.447540 202.509613,326.265411 190.824905,326.293457 
	C187.994965,326.300262 185.163300,326.353424 182.335327,326.277618 
	C173.356949,326.037018 167.954102,319.536346 169.337479,310.694061 
	C170.570724,302.811249 171.615677,294.892395 173.108795,287.059021 
	C174.212662,281.267670 172.532898,276.832153 168.545166,272.604980 
	C154.605637,257.828491 161.678497,233.676407 181.315628,228.501007 
	C194.731461,224.965225 207.579941,232.124619 212.530716,246.540619 
	C204.144608,246.964233 196.178894,246.972778 188.213196,246.989029 
	C182.270355,247.001144 178.816437,249.812302 178.708817,254.711349 
	C178.596268,259.835388 182.194931,262.873383 188.318085,262.905151 
	C196.445312,262.947327 204.572296,263.038361 212.699387,263.108398 
z"/>
<path fill="#0164FD" opacity="1.000000" stroke="none" 
	d="
M213.074982,262.996887 
	C204.572296,263.038361 196.445312,262.947327 188.318085,262.905151 
	C182.194931,262.873383 178.596268,259.835388 178.708817,254.711349 
	C178.816437,249.812302 182.270355,247.001144 188.213196,246.989029 
	C196.178894,246.972778 204.144608,246.964233 212.576813,246.894226 
	C215.408356,246.895248 217.773392,246.954437 220.578918,247.081207 
	C215.674881,253.342865 215.489090,255.664749 219.942337,262.322662 
	C217.852188,262.730743 215.651398,262.808044 213.074982,262.996887 
z"/>
<path fill="#FEAB01" opacity="1.000000" stroke="none" 
	d="
M324.467651,228.966034 
	C328.686981,240.941132 332.817505,252.799866 336.273163,264.852112 
	C337.866486,270.409088 338.139862,276.344513 339.057556,282.529694 
	C333.035278,285.614960 327.815094,282.686890 322.244720,279.743408 
	C320.836578,272.713623 320.006592,266.289276 318.428864,260.054138 
	C316.645172,253.004990 314.189972,246.125763 312.026794,239.172638 
	C314.927979,234.432755 318.472412,230.451172 324.467651,228.966034 
z"/>
<path fill="#FBC205" opacity="1.000000" stroke="none" 
	d="
M311.755463,239.379303 
	C314.189972,246.125763 316.645172,253.004990 318.428864,260.054138 
	C320.006592,266.289276 320.836578,272.713623 321.995056,279.476318 
	C307.642456,272.162201 303.090271,254.700592 311.755463,239.379303 
z"/>
<path fill="#FFF5CE" opacity="1.000000" stroke="none" 
	d="
M253.674896,219.528168 
	C256.279266,220.225449 258.427887,220.922256 260.576508,221.619049 
	C258.461884,222.346298 256.372559,223.597153 254.227829,223.700653 
	C248.271622,223.988083 242.287643,223.924149 236.325943,223.699234 
	C235.006866,223.649445 233.734421,222.363770 232.440506,221.647156 
	C233.728256,220.941711 234.993561,219.680328 236.307648,219.627274 
	C241.936981,219.400024 247.580688,219.528748 253.674896,219.528168 
z"/>
<path fill="#FFF5CE" opacity="1.000000" stroke="none" 
	d="
M132.575806,327.530518 
	C134.937881,327.846100 136.853226,328.161011 138.768585,328.475922 
	C138.796249,329.062408 138.823914,329.648895 138.851593,330.235382 
	C137.462585,330.755127 136.083160,331.691833 134.682983,331.723999 
	C127.866997,331.880341 121.041786,331.910797 114.229019,331.695587 
	C112.886154,331.653107 111.583649,330.333405 110.262543,329.602783 
	C111.563461,328.913177 112.844543,327.676025 114.168709,327.628082 
	C120.148819,327.411407 126.141136,327.531281 132.575806,327.530518 
z"/>
<path fill="#FFF6D4" opacity="1.000000" stroke="none" 
	d="
M158.797241,369.951416 
	C158.798187,364.463043 158.663025,359.458801 158.888321,354.470856 
	C158.950851,353.086548 160.082596,351.750488 160.723770,350.392273 
	C161.443329,351.644287 162.750900,352.880310 162.785461,354.150940 
	C162.984604,361.476044 162.984100,368.812073 162.787430,376.137299 
	C162.752899,377.423462 161.468307,378.676025 160.761017,379.944092 
	C160.107483,378.609283 159.140762,377.332581 158.879471,375.924957 
	C158.550568,374.153198 158.798355,372.274384 158.797241,369.951416 
z"/>
<path fill="#FFFAE3" opacity="1.000000" stroke="none" 
	d="
M207.995453,176.368790 
	C208.786972,174.389847 209.578384,172.865265 210.369781,171.340683 
	C210.914337,172.916519 211.886749,174.480988 211.928894,176.070145 
	C212.105530,182.730576 212.135147,189.402893 211.908096,196.060272 
	C211.853378,197.664459 210.610306,199.228149 209.913742,200.810455 
	C209.274323,199.146545 208.141678,197.499741 208.083298,195.815704 
	C207.864090,189.491425 207.995392,183.155014 207.995453,176.368790 
z"/>
<path fill="#FFF5CF" opacity="1.000000" stroke="none" 
	d="
M230.726898,203.846252 
	C228.956924,204.494476 227.448425,204.892319 225.939926,205.290161 
	C226.494888,203.906815 226.707642,202.196747 227.663193,201.195847 
	C232.142242,196.504303 236.744705,191.920380 241.504410,187.515594 
	C242.455933,186.635025 244.285797,186.703583 245.710663,186.334488 
	C245.272491,187.616013 245.184006,189.228165 244.337418,190.123505 
	C239.995087,194.715805 235.457657,199.123596 230.726898,203.846252 
z"/>
<path fill="#FFF6D2" opacity="1.000000" stroke="none" 
	d="
M135.270905,352.266602 
	C137.268570,350.237549 138.876968,348.281647 140.824051,346.758759 
	C141.730423,346.049835 143.293915,346.181091 144.559555,345.931519 
	C144.307755,347.090576 144.438461,348.607513 143.742691,349.351166 
	C138.861542,354.568329 133.863052,359.680511 128.749023,364.669342 
	C128.068146,365.333588 126.524536,365.113464 125.380455,365.302917 
	C125.579453,364.136139 125.380730,362.618988 126.046432,361.863373 
	C128.898911,358.625610 132.005981,355.612152 135.270905,352.266602 
z"/>
</svg>